import {useState} from "react";
import NarrowDrawer from "../../../../../components/general/NarrowDrawer.tsx";
import {SecondaryButton} from "../../../../../components/general/SecondaryButton.tsx";
import {createTable, PaginationState, SearchState, TableHeaderSpec} from "../../../../../components/table/CreateTable.tsx";
import {BankAccount} from "../entrepreneurSettingsPage/BankAccountsTable.tsx";

interface Props {
    open: boolean;
    relations: Array<BankAccount>;
    onClose: () => void;
    onSelect: (relation: BankAccount) => void;
}

const PAGE_SIZE = 15;

export function SavingsAccountPickerDrawer({open, relations, onClose, onSelect}: Props) {
    const tablePaginationState = useState<PaginationState<BankAccount>>();

    const tableSpec: TableHeaderSpec<BankAccount> = {
        title: `${relations.length} Relaties`,
        columns: [
            {
                name: 'Name',
                field: 'name',
                customRender: (row: BankAccount) => (
                    <div>
                        <p>{row.relation_name}</p>
                        <p className={'font-mono'}>{row.relation_iban}</p>
                    </div>
                )
            },
            {
                name: '',
                field: '_',
                customRender: (row: BankAccount) => (
                    <div className="flex justify-end">
                        <SecondaryButton title={'Toevoegen'} onClick={() => onSelect(row)}
                                         className="bg-transparent py-1 text-gray-500 hover:text-gray-700"/>
                    </div>
                )
            }
        ],
        pagination: {
            inMemory: true,
            paginationState: tablePaginationState,
            totalPages: Math.ceil(relations.length / PAGE_SIZE),
            defaultPageSize: PAGE_SIZE,
        },
        search: {
            searchFn: (row: BankAccount, searchState: SearchState) => {
                const query = searchState.currentQuery.toLowerCase();
                const nameMatches = row?.relation_name?.toLowerCase().includes(query);
                const ibanMatches = row?.relation_iban?.replace(/\s+/g, '').toLowerCase()
                    .includes(query.replace(/\s+/g, ''));
                return nameMatches || ibanMatches;
            }
        },
        onEmptyRender: () => (
            <p className="text-sm text-gray-600 py-4 text-center">
                {relations.length === 0
                    ? 'Geen beschikbare bankrekeningen om toe te voegen'
                    : 'Geen bankrekeningen gevonden'}
            </p>
        ),
        scroll: {
            maxHeight: 'calc(100vh - 220px)',
        },
        options: {
            hideTableHeader: true,
            disableTopPaginationWidget: true,
        }
    };

    const TableComponent = createTable<BankAccount>(relations, tableSpec);

    return (
        <NarrowDrawer open={open} title={'Selecteer een bankrekening'} updateOpenState={onClose}>
            {TableComponent()}
        </NarrowDrawer>
    );
}
